export default __webpack_public_path__ + "static/media/MoviesApp.99140c61.png";